import { toUnit } from '@99designs/spa-common';
import { CurrencyCode } from '@99designs/i18n';

const getMinimumFractionDigitForFormattedNumber = (
    amount: number,
    currency = CurrencyCode.USD
): number => {
    return toUnit(amount, currency) % 1 === 0 ? 0 : 2;
};

export default getMinimumFractionDigitForFormattedNumber;
